export default "__VITE_ASSET__BkiXaO$J__"